// A timer that fires this much later than it was due ran while the page was frozen (a background
// tab, or a phone that went to sleep), so the time it measured was not time spent waiting.
const SUSPENDED_TIMER_SLACK_MS = 5_000;

/**
 * Like setTimeout, but only counts time the page was running: when the timer fires late because the
 * page was frozen, it waits the full delay again from the moment the page resumed.
 *
 * @returns A function that cancels the timer.
 */
const setActiveTimeout = (callback: () => void, ms: number) => {
  let timeoutId: ReturnType<typeof setTimeout>;
  const arm = () => {
    const armedAt = Date.now();
    timeoutId = setTimeout(() => {
      if (Date.now() - armedAt > ms + SUSPENDED_TIMER_SLACK_MS) {
        arm();
        return;
      }
      callback();
    }, ms);
  };
  arm();
  return () => clearTimeout(timeoutId);
};

export default setActiveTimeout;
